import '../scss/exchange.scss';
import menuModule from "./modules/menu.js";
// import tableOfContentModule from "./modules/tableOfContentModule.js";
// import faqModule from "./modules/faqModule.js";
// import commentsModule from "./modules/commentsModule.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
import reviewsModule from "./modules/reviewsModule.js";
import compareFixedBtn from "./modules/compareFixedBtn.js";


// import priceCoinWidget from "./widgets/price-coin-widget.js";

(function ($) {
    $(document).ready(function () {
        window.$ = jQuery;
        menuModule.init();

        // // tableOfContentModule.init();
        // // faqModule.init();
        // // commentsModule.init();
        scrollUpModule.init();
        reviewsModule.init();
        footerModule.init();
        compareFixedBtn.init();
        // // priceCoinWidget.init();

        let page = 1;
        let sort = 'date';
        let direction = 'DESC';
        let mark = null;

        const setDataToPagination = () => {
            $('.reviews-pagination .page-numbers a, .reviews-pagination .page-numbers span').each(function () {
                const pageText = $(this).text().trim();
                $(this).attr('data-page', pageText);
            });
        }

        setDataToPagination();

        const setShowMore = () => {
            $('.review-content').each(function (){
                const h = $(this).height();

                if(h > 155) {
                    $(this).next('a').show();
                }

                console.log('setShowMore', h)
            });
        }

        setShowMore();

        const loadReviews = () => {
            $.post( ajaxurl, {
                    action: 'ajaxGetReviews',
                    page: page,
                    exchange_post_id: $('#review-exchange-id').data('post-id'),
                    sort: sort,
                    direction: direction,
                    mark: mark
                },
                function(response) {
                    if (response.success) {
                        $('#reviews-block').html(response.data.reviews);
                        console.log(+response.data.total)
                        if(+response.data.total > 0) {
                            $('.no-review').css('display', 'none');
                            $('.rating-sort-dropdown').css('display', 'block');
                            $('.reviews-pagination').css('display', 'flex');
                        } else {
                            $('.no-review').css('display', 'flex');
                            $('.rating-sort-dropdown').css('display', 'none');
                            $('.reviews-pagination').css('display', 'none');
                        }

                        $('.reviews-pagination').html(response.data.pagination);
                        // $('#countReviews').html(response.data.total);
                        // $('#avg').html(response.data.avg);

                        setShowMore();
                    }
                }
            );
        }

        $(document).on('click', '[data-filter-mark]', function (e) {
            e.preventDefault();

            $('[data-filter-mark]').removeClass('active')
            $(e.target).closest('[data-filter-mark]').addClass('active')

            mark = e.target.closest('[data-filter-mark]').dataset.filterMark;
            if(mark === 'all') mark = null;



            page = 1;

            loadReviews();
        })

        $(document).on('click', '[data-show-rating-widget-info]', function (e) {
            e.preventDefault();
            $(e.target).closest('.widget-exchange-info-2__reverse').toggleClass('show')
        })

        $('.rating-sort-dropdown-btn').on('click', function (e) {
            $(e.target).closest('.rating-sort-dropdown').toggleClass('open')
        })

        $('[data-reviews-sort]').on('click', function (e) {
            e.preventDefault();
            $(e.target).closest('.rating-sort-dropdown').removeClass('open');

            const text = $(e.target).text();
            $(e.target).closest('.rating-sort-dropdown').find('.rating-sort-dropdown-btn > span').text(text)

            sort = e.target.dataset.reviewsSort;
            direction = e.target.dataset.reviewsDirection;
            page = 1;

            loadReviews();
        })

        $(document).on('click', '[data-shop-toggle]', e => {
            e.preventDefault();
            const link = e.target;
            const wrap = link.closest('.review-content-wrap');
            $(wrap).toggleClass('expanded');

            link.textContent = wrap.classList.contains('expanded')
                ? link.dataset.showLess
                : link.dataset.showMore;
        })

        // document.querySelectorAll('.review-content-wrap').forEach(content => {
        //     const link = content.querySelector('a');
        //     if (!link) return;
        //
        //     link.addEventListener('click', (e) => {
        //         e.preventDefault();
        //         content.classList.toggle('expanded');
        //
        //         link.textContent = content.classList.contains('expanded')
        //             ? link.dataset.showLess
        //             : link.dataset.showMore;
        //     });
        // });

        // $('#reviewForm').on('change', '[data-rate-input]', function (e) {
        //     console.log(123)
        //
        //     // e.preventDefault();
        //     // const postId = e.target.closest('.block-rate-share').dataset.postId;
        //     //
        //     // const data = {
        //     //     action: 'markWidget',
        //     //     value: e.target.value,
        //     //     postId: postId,
        //     // };
        //     //
        //     // console.log(data)
        //
        //
        //     // $.post(ajaxurl, data, function (response) {
        //     //     response = JSON.parse(response);
        //     //
        //     //     $('[data-avg-mark]').text(Number.parseFloat(response.avgMark).toFixed(1))
        //     //     $('[data-count-mark]').text(response.count)
        //     //     $('[data-count-text]').text(response.text)
        //     //
        //     //
        //     //     localStorage.setItem('alreadyVoted', JSON.stringify(alreadyVoted));
        //     //     rateAndShareModule.setVote();
        //     // });
        // });
        //

        $(document).on('click', '.reviews-pagination .page-numbers[href]', e => {
            e.preventDefault();

            if(e.target.closest('a').classList.contains('current')) return false;

            const pages = $('.reviews-pagination .page-numbers').length - 2;

            if(e.target.closest('a').classList.contains('prev')) {
                page = page - 1 >= 1 ? page - 1 : 1;
            } else if(e.target.closest('a').classList.contains('next')) {
                page = page + 1 <= pages ? page + 1 : page;
            } else {
                page = e.target.innerText;
            }

            loadReviews();

            setDataToPagination();

            $('.reviews-pagination .page-numbers').removeClass('current');
            $('[data-page="'+page+'"]').closest('.page-numbers').addClass('current');

        })




    });


}(jQuery));
